import { selectUser, selectIsAuthenticated, selectIsUserSystemAdmin, selectUserRoles } from '@auth/state';
import type { UserRoles } from '@core/domain';
import { useAppSelector } from '@store';
import { useCallback } from 'react';

/**
 * Hook to access authentication state
 */
export function useAuthState() {
  const user = useAppSelector(selectUser);
  const userRoles = useAppSelector(selectUserRoles);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isUserSystemAdmin = useAppSelector(selectIsUserSystemAdmin);

  const hasRoleAccess = useCallback(
    (roleType: UserRoles, communityGroupId?: string, communityId?: string) => {
      if (isUserSystemAdmin || userRoles.includes(roleType)) {
        return true;
      }

      if (communityGroupId) {
        if (userRoles.includes(`${roleType}_${communityGroupId}`)) {
          return true;
        }

        if (communityId) {
          return userRoles.includes(`${roleType}_${communityGroupId}_${communityId}`);
        }
      }

      return false;
    },
    [isUserSystemAdmin, userRoles]
  );

  return {
    user,
    isAuthenticated,
    isUserSystemAdmin,
    hasRoleAccess,
  };
}
